<template>
  <SelfLearningResourcesSection ref="selfLearningResources"></SelfLearningResourcesSection>
</template>

<script>
  import SelfLearningResourcesSection from "./SelfLearningResourcesSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "SelfLearningResourcesWrapper",
    components: {
      SelfLearningResourcesSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
